import React, { FC } from 'react';

import styled from 'styled-components/macro';

import {
  Box,
  Drawer as MuiDrawer,
  DrawerProps,
  IconButton,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import SidebarNav from './SidebarNav';

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
    background: #0f172a;
  }
`;

type SideBarProps = DrawerProps & {
  onNavigationToggle?: React.MouseEventHandler<HTMLButtonElement>;
  showNavigationToggle?: boolean;
  collapsed?: boolean;
};

const Sidebar: FC<SideBarProps> = ({
  onNavigationToggle,
  showNavigationToggle = false,
  collapsed = false,
  ...props
}) => {
  return (
    <Drawer {...props}>
      {showNavigationToggle && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: collapsed ? 'center' : 'flex-start',
            px: collapsed ? 0 : 2.5,
            pt: 2,
            pb: 1,
          }}
        >
          <IconButton
            aria-label="Toggle navigation"
            onClick={onNavigationToggle}
            size="small"
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              color: '#cbd5e1',
              bgcolor: collapsed ? 'rgba(30, 41, 59, 0.72)' : 'transparent',
              '&:hover': { bgcolor: '#1e293b' },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      )}
      <SidebarNav collapsed={collapsed} />
    </Drawer>
  );
};

export default Sidebar;
